import { Env, readFromEnv } from '@cinch-nx/environments'
import type { VehicleListingResponse } from '@cinch-nx/shared-types'
import axios from 'axios'
import useSWR from 'swr'

export const VEHICLE_SEARCH_URL = `${readFromEnv(
  Env.SearchServiceUrl,
)}/vehicles`

const fetcher = (url: string) => axios.get(url).then((res) => res.data)

export interface args {
  count?: number
  seats?: string
  bodyType?: string
  colour?: string
}

export const useFeaturedEVs = ({
  count = 12,
  bodyType,
  seats,
  colour,
}: args) => {
  const queryObject: Record<string, string> = {
    sortingCriteria: '2',
  }
  let browseButtonUrl = '/used-cars'
  const searchFilter: Record<string, string | undefined> = {
    fuelType: 'electric',
    bodyType,
    seats,
    colour,
  }
  for (const key in searchFilter) {
    if (
      Object.prototype.hasOwnProperty.call(searchFilter, key) &&
      searchFilter[key] &&
      searchFilter[key] !== ''
    ) {
      const filter = key
      const filterValue = searchFilter[key] as string
      queryObject[filter] = filterValue
      browseButtonUrl = `/used-cars?${filter}=${filterValue}`
      break
    }
  }

  const qs = new URLSearchParams(queryObject)
  const url = `${VEHICLE_SEARCH_URL}?${qs.toString()}`

  const { data, error } = useSWR<VehicleListingResponse>(url, fetcher)
  const countOfData = data?.searchResultsCount
  data?.vehicleListings.splice(count)
  return { data, countOfData, browseButtonUrl, error }
}
